import axios from 'axios';

import { ApiConstant } from '../../../../constants';

export const getChallenges = ({ filterType, filterInOrder, filterActive, filterOneShot }) => {
  return new Promise((resolve, reject) => {
    /* Actually, the dev didn't use Token */
    const token = localStorage.getItem('adminToken');
    if (token) {
      axios.defaults.headers.common.Authorization = token;
    }

    const body = {
      action: 'GET_CHALLENGES',
      filterType,
      filterInOrder,
      filterActive,
      filterOneShot
    };

    axios
      .post(`${ApiConstant.BASE_URL}problem/`, body)
      .then((response) => {
        if (response.data.success) {
          resolve(response.data.result);
        } else {
          const error = new Error(response.data.message);
          error.code = response.data.code;
          throw error;
        }
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const getChallengesWithTypes = ({ filterType, filterInOrder, filterActive, filterOneShot }) => {
  return new Promise((resolve, reject) => {
    const body = {
      action: 'GET_CHALLENGES_WITH_TYPES',
      filterType,
      filterInOrder,
      filterActive,
      filterOneShot
    };

    axios
      .post(`${ApiConstant.BASE_URL}common/`, body)
      .then((response) => {
        if (response.data.success) {
          resolve(response.data.result);
        } else throw new Error(response.data.error);
      })
      .catch(error => {
        reject(error);
      });
  });
};

/* Get the upload info */
export const getChallengeUploadOptions = (challenge_id) => {
  return new Promise((resolve, reject) => {
    const body = {
      action: 'GET_CHALLENGE_UPLOAD_OPTIONS',
      challenge_id
    };

    axios
      .post(`${ApiConstant.BASE_URL}common/`, body)
      .then((response) => {
        if (response.data.success) {
          resolve(response.data.result);
        } else throw new Error(response.data.error);
      })
      .catch(error => {
        reject(error);
      });
  });
};

/* Get the upload info from a user with challenge id */
export const getChallengeUploadByUser = (challenge_id) => {
  return new Promise((resolve, reject) => {
    /* Messed up with the AdminToken */
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common.Authorization = token;
    }

    const body = {
      action: 'GET_CHALLENGE_UPLOAD_BY_USER',
      challenge_id
    };

    axios
      .post(`${ApiConstant.BASE_URL}challenge/`, body)
      .then((response) => {
        if (response.data.success) {
          resolve(response.data.result);
        } else throw new Error(response.data.error);
      })
      .catch(error => {
        reject(error);
      });
  });
};

/* Check if all the conditions are satified for accessing the current challenge */
export const checkValid = ({ challenge_id, job_id }) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common.Authorization = token;
    }

    const body = {
      challenge_id,
      job_id
    };

    axios
      .post(`${ApiConstant.BASE_URL}check-valid/`, body)
      .then((response) => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};

/* Check if basic challenges are passed or not */
export const checkBasicChallengesPassed = (profileDetailRequired) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common.Authorization = token;
    }

    const body = {
      action: 'BASIC_CHALLENGES_PASSED',
      profileDetailRequired: (parseInt(profileDetailRequired, 10) === 1) ? 1 : 0
    };

    axios
      .post(`${ApiConstant.BASE_URL}challenge/`, body)
      .then((response) => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};

/* Return all participated data for an user and a challenge */
export const checkParticiparted = (challenge_id, step = null) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common.Authorization = token;
    }

    const body = {
      action: 'CHECK_PARTICIPARTED',
      challenge_id: challenge_id,
      step: step
    };

    axios.post(`${ApiConstant.BASE_URL}challenge/`, body)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};

/* Return all participated data for an user and a challenge */
export const getTrackChallenge = (challenge_id) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common.Authorization = token;
    }

    const body = {
      action: 'GET_TRACK_CHALLENGE',
      challenge_id: challenge_id
    };

    axios.post(`${ApiConstant.BASE_URL}challenge/`, body)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const callChallengeAction = (action, params) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common.Authorization = token;
    }

    const body = {
      action,
      ...params
    };

    axios.post(`${ApiConstant.BASE_URL}challenge/`, body)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const getLabSessionCredentials = (lab_id) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common.Authorization = token;
    }

    const body = {
      lab_id
    };

    axios.post(`${ApiConstant.BASE_URL}create-new-lab-session/`, body)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error);
      });
  });
}
